import React from 'react';
import { Container } from '@atlassian/jira-common-directory-v2/src/components/text-cell/styled';
import { injectIntlV2 as injectIntl, type IntlShapeV2 as IntlShape } from '@atlassian/jira-intl';

import messages from './messages';

type Props = {
	popularity: number | undefined;
	intl: IntlShape;
};

function Popularity(props: Props) {
	const {
		popularity,
		intl: { formatMessage },
	} = props;

	return <Container>{formatMessage(messages.popularity, { popularity })}</Container>;
}

export default injectIntl(Popularity);
